import { Endpoint, api } from "../data/api";

export function login(username: string, password: string): Promise<any[]> {
  return api.post(Endpoint.login, { username, password });
}